import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AppText, Column, styled } from '@streem/ui-react';
import { useInvitationDetails } from '../../context/invitation_details';
import { useCompanySettings } from '../../context/company_settings';
import { Intro } from './intro';
import { WideButton } from './wide_button';
import { PoweredByStreemFooter } from '../lobby/powered_by_streem_footer';
import { recordScreenViewed } from '@streem/analytics';
const ExpirationText = ({ expiresIn, }) => {
    const text = expiresIn ? `Invitation expires in ${expiresIn}` : '';
    return (_jsx(ExpirationTextContainer, { children: _jsx(AppText, { as: "p", color: "medium", children: text }) }));
};
export const CallGetStarted = props => {
    const { agentName, agentBio, agentAvatar, companyName, expiresIn } = useInvitationDetails();
    const { logoUrl } = useCompanySettings();
    const pluralizeExpiresIn = (timeRemaining) => {
        if (timeRemaining < 1) {
            return 'less than a minute';
        }
        else {
            const roundedDuration = Math.ceil(timeRemaining);
            return timeRemaining === 1 ? `${roundedDuration} minute` : `${roundedDuration} minutes`;
        }
    };
    const [humanizedExpiresIn, setHumanizedExpiresIn] = useState(pluralizeExpiresIn(expiresIn()));
    useEffect(() => {
        const expirationChecker = setInterval(() => {
            const updatedExpiresIn = pluralizeExpiresIn(expiresIn());
            if (updatedExpiresIn !== humanizedExpiresIn) {
                setHumanizedExpiresIn(updatedExpiresIn);
            }
        }, 10000);
        return () => clearInterval(expirationChecker);
    }, [expiresIn, humanizedExpiresIn]);
    useEffect(() => {
        recordScreenViewed('call: get started');
    }, []);
    return (_jsxs(TopColumn, { children: [_jsx(Intro, { avatarSrc: agentAvatar, displayName: agentName, bio: agentBio, company: companyName, logo: logoUrl, size: "large" }), _jsx(GetStartedButton, { onClick: props.onStart }), _jsx(ExpirationText, { expiresIn: humanizedExpiresIn }), !props.hideStreemBranding && _jsx(PoweredByStreemFooter, {})] }));
};
const GetStartedButton = ({ onClick, }) => {
    return (_jsx(WideButton, { testid: "get-started-btn", "data-streem-analytics": "call-get-started-button", onClick: onClick, children: "Get Started" }));
};
const TopColumn = styled(Column)({
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100vw',
    marginTop: '10vh',
});
const ExpirationTextContainer = styled.div(({ theme }) => ({
    color: theme.colors.grey30,
    marginTop: theme.space[3],
}));
//# sourceMappingURL=call_get_started.js.map